let key = "brule-cream-birthdate-validated";

window.addEventListener("DOMContentLoaded", () => {
  const birthdateValidated = getLocalStorageWithExpiry(key) || getCookie(key);
  const birthdateSection = document.querySelector(
    ".birthdate-validation-section"
  );

  const isValidated = birthdateValidated === true || birthdateValidated === "true";

  if (isValidated || !birthdateSection) {
    hideBirthdateValidation(birthdateSection);
  } else {
    showBirthdateValidation(birthdateSection);
  }
});

function handleBirthdateForm(birthdateSection) {
  const birthdateForm = document.getElementById("birthdate-form");

  if (birthdateForm) {
    birthdateForm.addEventListener("submit", function (e) {
      e.preventDefault();

      const rememberMe = document.getElementById("remember-me");
      const isValid = e.submitter?.value;

      console.log("isValid", isValid);

      if (isValid === "true") {
        if (rememberMe && rememberMe.checked) {
          setLocalStorageWithExpiry(key, true, 15);
        } else {
          setCookie(key, true, 24);
        }

        hideBirthdateValidation(birthdateSection);
      } else {
        handleFeedbackMessage(birthdateSection);
      }
    });
  }
}


function setCookie(name, value, hours) {
  const now = new Date();
  now.setTime(now.getTime() + hours * 60 * 60 * 1000);
  document.cookie = `${name}=${value}; expires=${now.toUTCString()}; path=/`;
}

function getCookie(name) {
  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  return match ? match[2] : null;
}

function setLocalStorageWithExpiry(name, value, days) {
  try {
    const ttl = days * 24 * 60 * 60 * 1000;
    const item = {
      value,
      expiresAt: Date.now() + ttl,
    };
    localStorage.setItem(name, JSON.stringify(item));
  } catch (_) {
    // no-op if storage unavailable
  }
}

function getLocalStorageWithExpiry(name) {
  try {
    const raw = localStorage.getItem(name);
    if (raw == null) return null;
    const parsed = JSON.parse(raw);
    if (parsed && typeof parsed === "object" && Object.prototype.hasOwnProperty.call(parsed, "expiresAt")) {
      if (Date.now() > parsed.expiresAt) {
        localStorage.removeItem(name);
        return null;
      }
      return parsed.value;
    }
    return parsed;
  } catch (_) {
    try {
      const fallback = localStorage.getItem(name);
      return fallback;
    } catch (_) {
      return null;
    }
  }
}

function showBirthdateValidation(birthdateSection) {
  if (!birthdateSection) return;
  const birthdateSectionContent = birthdateSection.querySelector(
    ".birthdate-validation-container"
  );
  if (birthdateSectionContent) {
    const isDesignMode = birthdateSectionContent.classList.contains("design-mode");
    birthdateSectionContent.classList.remove("hidden");
    handleInfiniteSliderBar(false);
    if (isDesignMode) {
      document.body.classList.remove("overflow-hidden");
    } else {
      document.body.classList.add("overflow-hidden");
    }
  }

  handleBirthdateForm(birthdateSection);
  handleBirthdateSelect();
}

function hideBirthdateValidation(birthdateSection) {
  birthdateSection?.classList?.add("hidden");
  document.body.classList.remove("overflow-hidden");
  handleInfiniteSliderBar();
}

function handleInfiniteSliderBar(show_bar = true) {
  const announcementBar = document.querySelector(".announcement-bar");
  if (!announcementBar) {
    return;
  }

  if (show_bar) {
    announcementBar.classList.remove("hidden");
  } else {
    announcementBar.classList.add("hidden");
  }
}

function handleFeedbackMessage(birthdateSection) {
  localStorage.removeItem(key);

  const firstParagraph = birthdateSection?.querySelector(
    ".paragraph"
  );
  const feedbackMessage = birthdateSection.querySelector(
    ".birthdate-feedback-message"
  );

  if (feedbackMessage) {
    feedbackMessage.classList.remove("hidden");
    if (firstParagraph) firstParagraph.classList.add("hidden");
  }
  birthdateSection.classList.add("invalid");
}

function handleBirthdateSelect() {
  const section = document.querySelector(".birthdate-validation-section");
  if (!section) return;

  const dayInput = section.querySelector('#birthdate-day, [name="birthdate-day"], [data-birth-part="day"]');
  const monthInput = section.querySelector('#birthdate-month, [name="birthdate-month"], [data-birth-part="month"]');
  const yearInput = section.querySelector('#birthdate-year, [name="birthdate-year"], [data-birth-part="year"]');
  const submitButtons = section.querySelectorAll('button[type="submit"], input[type="submit"]');

  if (!submitButtons.length) return;

  const toInt = (v) => {
    const n = parseInt(v, 10);
    return Number.isFinite(n) ? n : NaN;
  };

  const update = () => {
    const day = dayInput ? toInt(dayInput.value) : NaN;
    const month = monthInput ? toInt(monthInput.value) : NaN;
    const year = yearInput ? toInt(yearInput.value) : NaN;
    const valid = isAdult(year, month, day, 18);
    submitButtons.forEach((btn) => {
      btn.dataset.valid = String(valid);
    });
  };

  [dayInput, monthInput, yearInput].forEach((el) => {
    if (el) el.addEventListener("change", update);
  });

  update();
}

function isAdult(year, month, day, minAge) {
  if (!Number.isFinite(year) || !Number.isFinite(month) || !Number.isFinite(day)) return false;
  const dob = new Date(year, (month || 1) - 1, day || 1);
  if (isNaN(dob.getTime())) return false;
  const today = new Date();
  const threshold = new Date(today.getFullYear() - (minAge || 18), today.getMonth(), today.getDate());
  return dob <= threshold;
}